<template>
    <div>
        <div class="h-bar">
            <div class="name">Hasta Takibi ve Tablolar</div>
        </div>
        <div id="content" class="takip-content">
            <div class="y-sarilik">
                <div class="fototerapi" v-for="p in patients" :key="p.id">
                    <div
                        class="content"
                        @click.prevent="
                            visibleItem == p.id
                                ? (visibleItem = -1)
                                : (visibleItem = p.id)
                        "
                    >
                        <div class="name">
                            {{ p.name }} <span> x{{ p.tcb }}</span>
                        </div>
                        <div class="details">
                            <i class="fa fa-baby"></i> {{ gh(p) }},
                            {{ p.dtarti }} gr
                            <br />
                            {{ p.coombs }}
                        </div>
                        <div class="hafta"></div>
                        <div class="now">
                            <span class="saat blink">{{
                                p.birth | toYDGun
                            }}</span>
                        </div>
                        <template v-if="p.dhafta < 35">
                            <div
                                class="f-widget blink"
                                :class="riskpreterm(p).class"
                            >
                                <div class="value">
                                    {{ riskpreterm(p).title + " Risk" }}
                                </div>
                                <div class="sinir">
                                    <span class="birim">
                                        {{ tcb(p)[riskpreterm(p).sira] }}
                                    </span>
                                </div>
                            </div>
                        </template>
                        <template v-if="p.dhafta >= 35">
                            <div class="f-widget blink" :class="risk(p).class">
                                <div class="value">
                                    {{ risk(p).title + " Risk" }}
                                </div>
                                <div class="sinir">
                                    {{ tcb(p)[risk(p).sira] }}
                                </div>
                            </div>
                        </template>
                    </div>
                    <transition name="fadeHeight">
                        <div
                            class="extra"
                            :class="visibleItem == p.id ? 'expand' : ''"
                        >
                            <template v-if="p.dhafta < 35">
                                <div class="f-widget medium">
                                    <div class="value">Düşük Risk</div>
                                    <div class="sinir">
                                        {{ tcb(p)[0] }}
                                        <span class="birim"> </span>
                                    </div>
                                </div>
                                <div class="f-widget high">
                                    <div class="value">Yüksek Risk</div>
                                    <div class="sinir">
                                        {{ tcb(p)[1] }}
                                        <span class="birim"> </span>
                                    </div>
                                </div>

                                <div class="f-widget exchange">
                                    <div class="value">Exchange</div>
                                    <div class="sinir">
                                        {{ tcb(p)[2] }}
                                    </div>
                                </div>
                            </template>
                            <template v-if="p.dhafta >= 35">
                                <div class="f-widget low">
                                    <div class="value">Düşük Risk</div>
                                    <div class="sinir">
                                        {{ tcb(p)[0] }}
                                    </div>
                                </div>
                                <div class="f-widget medium">
                                    <div class="value">Orta Risk</div>
                                    <div class="sinir">
                                        {{ tcb(p)[1] }}
                                    </div>
                                </div>
                                <div class="f-widget high">
                                    <div class="value">Yüksek Risk</div>
                                    <div class="sinir">
                                        {{ tcb(p)[2] }}
                                    </div>
                                </div>
                            </template>
                        </div>
                    </transition>
                </div>
            </div>
            <div class="card card-fw" id="grafikler">
                <p class="header bg-blue">Tablo ve Grafikler</p>
                <div class="y-grafik">
                    <ul class="grafik-tabs">
                        <li
                            @click.prevent="setGrafikTabActive(1)"
                            :class="{ active: isGrafikTabActive(1) }"
                        >
                            Fototerapi
                        </li>
                        <li
                            @click.prevent="setGrafikTabActive(2)"
                            :class="{ active: isGrafikTabActive(2) }"
                        >
                            Exchange
                        </li>
                        <li
                            @click.prevent="setGrafikTabActive(3)"
                            :class="{ active: isGrafikTabActive(3) }"
                        >
                            Exchange (Kan)
                        </li>
                        <li
                            @click.prevent="setGrafikTabActive(4)"
                            :class="{ active: isGrafikTabActive(4) }"
                        >
                            Göbek Katateri
                        </li>
                    </ul>
                    <div class="tab-content" v-show="isGrafikTabActive(1)">
                        <img src="/docimages/yenidogan/fototerapi.png" alt />
                    </div>
                    <div class="tab-content" v-show="isGrafikTabActive(2)">
                        <img src="/docimages/yenidogan/exchange.png" alt />
                    </div>
                    <div class="tab-content" v-show="isGrafikTabActive(3)">
                        <img src="/docimages/yenidogan/exchangekan.png" alt />
                    </div>
                    <div class="tab-content" v-show="isGrafikTabActive(4)">
                        <img src="/docimages/yenidogan/gobek.png" alt />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
export default {
    name: "TCB",
    data() {
        return {
            activeTab: 1,
            activeMainTab: 1,
            visibleItem: -1,
        };
    },
    computed: {
        patientList() {
            let items = [...this.$store.getters.getTCB];
            return items;
        },
        patients() {
            var result = _.chain(this.patientList).orderBy("kuvoz").value();
            return result;
        },
        fotolist() {
            return this.$store.getters.getFototerapi;
        },
    },
    methods: {
        // Tabs
        isTabActive(menuItem) {
            return this.activeMainTab === menuItem;
        },
        setTabActive(menuItem) {
            this.activeMainTab = menuItem;
        },

        // Tedavi Tabs
        isGrafikTabActive(menuItem) {
            return this.activeTab === menuItem;
        },
        setGrafikTabActive(menuItem) {
            this.activeTab = menuItem;
        },
        saatFarki(b1) {
            var hours = this.$moment().diff(this.$moment(b1), "hours", true);
            return Math.ceil(hours);
        },
        gh(p) {
            return p.dhafta + "w" + (p.dgun > 0 ? "+" + p.dgun + "d" : "");
        },
        risk(p) {
            var r = { sira: 2, class: "high", title: "Yüksek" };
            switch (true) {
                case p.coombs == "D.Coombs (-)" && p.dhafta >= 38:
                    r = { sira: 0, class: "low", title: "Düşük" };
                    break;
                case (p.coombs != "D.Coombs (-)" && p.dhafta >= 38) ||
                    (p.coombs == "D.Coombs (-)" && p.dhafta < 38):
                    r = { sira: 1, class: "medium", title: "Orta" };
                    break;
                case p.coombs != "D.Coombs (-)" && p.dhafta < 38:
                    r = { sira: 2, class: "high", title: "Yüksek" };
                    break;
            }
            return r;
        },
        riskpreterm(p) {
            var r = { sira: 1, class: "high", title: "Yüksek" };
            switch (true) {
                case p.coombs == "D.Coombs (-)":
                    r = { sira: 0, class: "low", title: "Düşük" };
                    break;
                case p.coombs != "D.Coombs (-)":
                    r = { sira: 1, class: "high", title: "Yüksek" };
                    break;
            }
            return r;
        },
        tcb(p) {
            var dt, dogum;
            dt = p.dtarti;
            dogum = this.saatFarki(p.birth);
            //var dr, or, yr, saat;
            //var a1, a2, a3, a4, sinir;
            if (p.dhafta < 35) {
                var sinir;
                this.fotolist.preterm.forEach((element) => {
                    if (
                        parseInt(element.h_min) <= dogum &&
                        parseInt(element.tarti_min) <= dt
                    ) {
                        sinir = [
                            element.dusuk,
                            element.yuksek,
                            element.exchange,
                        ];
                    }
                });
                return sinir;
            } else {
                var sarilik;
                if (dogum > 120) {
                    dogum = 120;
                }
                sarilik = this.fotolist.term.find(
                    (t) => t.h_min === dogum.toString()
                );
                return [sarilik["dusuk"], sarilik["orta"], sarilik["yuksek"]];
            }
        },

        getYatanlar() {
            // this.patientList = this.$store.getters.getPatients.yd;
            //this.$store.getters.getPatients.yd.forEach((element) => {
            //    this.patientList.push({ ...element, visible: false });
            //});

            if (this.$route.name == "TCB") {
                setInterval(() => this.getYatanlar(), 3600000);
            }
        },
    },
    created() {
        this.getYatanlar();
    },
};
</script>

<style lang="scss">
// Animation

.takip-content {
    padding: 68px 0 0 0 !important;
    display: flex;
    flex-wrap: wrap;
}
.y-sarilik {
    flex: 1 1 auto;
    display: grid;
    grid-gap: 15px;
    padding: 15px;
    align-items: start;
    grid-template-columns: repeat(auto-fit, minmax(25%, 1fr));

    .w-8 {
        width: 8%;
    }
    .w-12 {
        width: 12%;
    }
    h3 {
        text-align: center;
        padding: 20px 0;
    }
}
span.saat {
    font-weight: bold;
    color: $blue;
}

@media print {
    #grafikler {
        display: none;
    }
}

@media (max-width: 1280px) {
    .y-sarilik {
        flex: 1 1 auto;
    }
}
</style>